import ERC20ABI from "./ERC20";
import PRBProxy from "./PRBProxy";
import PRBProxyRegistry from "./PRBProxyRegistry";
import Permit2ABI from "./Permit2";
import SablierV2LockupDynamicABI from "./SablierV2LockupDynamic";
import SablierV2LockupLinearABI from "./SablierV2LockupLinear";
import SablierV2ProxyPlugin from "./SablierV2ProxyPlugin";
import SablierV2ProxyTargetApprove from "./SablierV2ProxyTargetApprove";
import SablierV2ProxyTargetPermit2 from "./SablierV2ProxyTargetPermit2";
import TargetWithdrawer from "./TargetWithdrawer";

const abis = {
  ERC20ABI,
  SablierV2LockupLinearABI,
  SablierV2LockupDynamicABI,
  PRBProxyRegistry,
  Permit2ABI,
  SablierV2ProxyTargetPermit2,
  SablierV2ProxyTargetApprove,
  PRBProxy,
  SablierV2ProxyPlugin,
  TargetWithdrawer,

  LockupLinear: SablierV2LockupLinearABI,
  LockupDynamic: SablierV2LockupDynamicABI,

  linear: SablierV2LockupLinearABI,
  dynamic: SablierV2LockupDynamicABI,
  permit: Permit2ABI,
  plugin: SablierV2ProxyPlugin,
  proxy: PRBProxy,
  registry: PRBProxyRegistry,
  target: SablierV2ProxyTargetPermit2,
  targetPermit2: SablierV2ProxyTargetPermit2,
  targetApprove: SablierV2ProxyTargetApprove,
  token: ERC20ABI,
  targetWithdrawer: TargetWithdrawer,
} as const;

export default abis;
